import { BoxTemplate, defaultBoxData } from '../../components/box/c-box.template'
import { TitleTemplate, defaultTitleData } from '../../components/title/c-title.template'
import { BtnTemplate, defaultButtonData } from '../../components/btn/c-btn.template'

const bookingLuggageMessageTemplateConsts = {
  box: {
    variant: 'flat',
    extraClasses: 'w-booking-luggage__message'
  },
  externalFlightBox: {
    variant: 'flat',
    extraClasses: 'w-booking-luggage__external-flight-message cs-state-info cs-state-info--light'
  },
  title: {
    size: 'tiny',
    extraClasses: 'w-booking-luggage__message-title',
    attributes: ''
  }
}

export const BookingLuggageMessageTemplate = (d) => {
  const boxExtraClasses = `${bookingLuggageMessageTemplateConsts.box.extraClasses} ${d.extraClasses}`
  const html = `
    ${TitleTemplate({ ...defaultTitleData, ...bookingLuggageMessageTemplateConsts.title, ...{ text: d.title } })}
    <div class="w-booking-luggage__message-description">
      ${d.description}
    </div>
    ${d.outboundFlightDefinition && d.outboundFlightDefinition.shouldBeShown
      ? `<hr class="w-booking-luggage__message-line">
        <div class="w-booking-luggage__message-airline-info">
          <div class="w-booking-luggage__message-dummy"></div>
          <div class="w-booking-luggage__message-airline-info--outbound w-booking-luggage__message-wide">
          <div class="w-booking-luggage__message-direction-title">${d.outboundFlightDefinition.title} ${d.outboundFlightDefinition.airline ? `<span> - ${d.outboundFlightDefinition.airline}</span>` : ''} </div>
          ${d.outboundFlightDefinition.checkedInLuggage || d.outboundFlightDefinition.handLuggage
            ? `<ul class="w-booking-luggage__list">
              ${d.outboundFlightDefinition.handLuggage ? `<li>${d.outboundFlightDefinition.handLuggage}</li>` : ''}
              ${d.outboundFlightDefinition.checkedInLuggage ? `<li>${d.outboundFlightDefinition.checkedInLuggage}</li>` : ''}
              </ul>`
            : ''}
          </div>`
      : ''}
      ${d.inboundFlightDefinition && d.inboundFlightDefinition.shouldBeShown
        ? `<hr class="w-booking-luggage__message-line">
          <div class="w-booking-luggage__message-airline-info--inbound w-booking-luggage__message-wide">
          <div class="w-booking-luggage__message-direction-title">${d.inboundFlightDefinition.title} ${d.inboundFlightDefinition.airline ? `<span> - ${d.inboundFlightDefinition.airline}</span>` : ''} </div>
          ${d.inboundFlightDefinition.checkedInLuggage || d.inboundFlightDefinition.handLuggage
            ? `<ul class="w-booking-luggage__list">
                ${d.inboundFlightDefinition.handLuggage ? `<li>${d.inboundFlightDefinition.handLuggage}</li>` : ''}
                ${d.inboundFlightDefinition.checkedInLuggage ? `<li>${d.inboundFlightDefinition.checkedInLuggage}</li>` : ''}
              </ul>`
            : ''}
          </div>`
    : ''}
    ${d.outboundFlightDefinition && d.outboundFlightDefinition.shouldBeShown ? '<div class="w-booking-luggage__message-dummy"></div></div>' : ''}
  `
  return `
    ${BoxTemplate({ ...defaultBoxData, ...bookingLuggageMessageTemplateConsts.box, ...{ html, extraClasses: boxExtraClasses } })}
  `
}

export const BookingLuggageExternalFlightsSSRTemplate = (externalFlightServiceLuggageInformation) => {
  if (!externalFlightServiceLuggageInformation) { return '' }
  const html = `
      <div class="w-booking-luggage__message-description sp-stack-children--small">
        ${TitleTemplate({ ...defaultTitleData, ...bookingLuggageMessageTemplateConsts.title, ...{ text: externalFlightServiceLuggageInformation.title } })}
        <div>${externalFlightServiceLuggageInformation.description}</div>
        ${externalFlightServiceLuggageInformation.button && externalFlightServiceLuggageInformation.button.url
? `
          <div class="w-booking-luggage__message-airline-info--external-ssr">
            ${BtnTemplate({
              ...defaultButtonData,
              ...{
                variant: 'flow',
                text: externalFlightServiceLuggageInformation.button.text || 'Go to airline',
                track: 'booking-luggage-external-flight-service-button',
                link: {
                  href: externalFlightServiceLuggageInformation.button.url,
                  title: externalFlightServiceLuggageInformation.button.text,
                  target: '_blank'
                }
              }
            })
            }
        </div>`
: ''}
      </div>`

  return `
    <label class="w-booking-luggage__external-flight-ssr-label c-dropdown__label e-form-label">${externalFlightServiceLuggageInformation.label}</label>
     ${BoxTemplate(
        {
 ...defaultBoxData,
          ...bookingLuggageMessageTemplateConsts.externalFlightBox,
          ...{
            html,
            extraClasses: `${bookingLuggageMessageTemplateConsts.externalFlightBox.extraClasses}`
          }
        }
        )
      }
    `
}
